<template>
    <div>

        <!-- tool images -->
        <div :class="{'flex' : !isHorizontal}">

            <div style="flex: 4" :class="{'mr4' : !isHorizontal}" class="w-70-l ba b--light-gray">
                <img :src="imagePath" class="w-100 h-100"/>
            </div>

            <!-- secondary images -->
            <slot></slot>
        </div>

        <!-- brand and description -->
        <div class="pv4">
            <h5>{{tool.title}}</h5>
            <h6 class="mb3 mid-gray">by <b>{{tool.brand}}</b></h6>
            <div>{{tool.description}}</div>
        </div>

    </div>
</template>

<script>
import Checkbox from '@/components/controls/Checkbox.vue';
import SettingSection from '@/components/accountSettings/shared/SettingSection.vue';

export default {
    components: {
        Checkbox,
        SettingSection
    },
    props: {
        tool: {
            type: Object
        },
        imageIndex: {
            type: Number,
            default: 0
        }
    },
    computed: {
        xs() {
            return this.$mq === 'xs';
        },
        mq() {
            return this.$mq;
        },
        imagePath() {
            return this.tool.images[this.imageIndex].path;
        },
        isHorizontal() {
            return this.$mq === 'xs' || this.$mq === 'md';
        }
    }
};
</script>
